"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unless(predicate, process) {
    return function (input) { return (predicate(input) ? input : process(input)); };
}
exports.default = unless;
//# sourceMappingURL=unless.js.map